import React from 'react';
import type { ColumnType } from './type';

export const getCellText = (value: any): string => {
  if (value == null) return '';

  if (['string', 'number', 'boolean'].includes(typeof value)) {
    return String(value);
  }

  if (Array.isArray(value)) {
    return value.map(getCellText).join(' ');
  }

  if (React.isValidElement(value)) {
    const element = value as React.ReactElement<any>;
    return getCellText(element.props?.children);
  }

  return '';
};

const normalizeText = (value: string): string => value.replace(/\s+/g, ' ').trim();

export const getColumnText = <T,>(column: ColumnType<T> | undefined, row: T): string => {
  if (!column) return '';

  const cellText = column.cell ? getCellText(column.cell(row)) : '';
  const selectorText = column.selector ? getCellText(column.selector(row)) : '';

  if (cellText && selectorText && !cellText.toLowerCase().includes(selectorText.toLowerCase())) {
    return normalizeText(`${cellText} ${selectorText}`);
  }

  return normalizeText(cellText || selectorText);
};

export const highlightText = (text: string, term: string): React.ReactNode => {
  if (!term) return text;

  const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedTerm})`, 'gi');

  return text
    .split(regex)
    .map((part) => (part.toLowerCase() === term.toLowerCase() ? `[${part}]` : part));
};
